import { writable } from 'svelte/store';

let siteText            = 'Imobiliária Yara';
let siteDescription     = 'Locação, Compra e Venda de Imóveis, Administração de Condomínios e Assessoria Jurídica';

export let tagsSEO      = writable('Locação, Compra e Venda de Imóveis, Administração de Condomínios e Assessoria Jurídica');

export const alt                = writable(siteText);
export const headerTitleHome    = writable(siteText + " | " + siteDescription);
export const headerTitle        = writable("| " + siteText);
export const textSite           = writable(siteText);

// E-mails
export const mailAtendimento    = writable("yara@imobiliariayara.com.br ");
export const mailLocacao        = writable("camila@imobiliariayara.com.br");
export const mailVendas         = writable("camila@imobiliariayara.com.br");
export const mailCondominios    = writable("yara@imobiliariayara.com.br ");
export const mailOuvidoria      = writable("yara@imobiliariayara.com.br ");
export const mailRH             = writable("yara@imobiliariayara.com.br ");
export const mailLista          = writable("camila@imobiliariayara.com.br");
export const mailAtualize       = writable("yara@imobiliariayara.com.br ");

export const textTelefone       = writable("(51) 3342-0572");
export const linkTelefone       = writable("tel://5133420572");

export const whatsapp                   = writable("5551000000000");
export const textWhatsapp               = writable("(51) 00000-0000");
export const linkWhatsapp               = writable("https://wa.me/5551000000000");

export const whatsappBoletos            = writable("5551995713203");
export const textWhatsappBoletos        = writable("(51) 99571-3203");
export const linkWhatsappBoletos        = writable("https://wa.me/5551995713203");

export const whatsappLocacao            = writable("555191358232");
export const textWhatsappLocacao        = writable("(51) 9135-8232");
export const linkWhatsappLocacao        = writable("https://wa.me/555191358232");

export const whatsappVendas             = writable("5551991358232");
export const textWhatsappVendas         = writable("(51) 99135-8232");
export const linkWhatsappVendas         = writable("https://wa.me/5551991358232");

export const textWhatsappCondominios    = writable("(51) 00000-0000");
export const linkWhatsappCondominios    = writable("https://wa.me/5551000000");

// Links
export const linkPesquisaVendas         = writable("/imoveis/vendas#nt=-2&tipo_negociacao=-2&cidade=Porto%20Alegre");
export const linkPesquisaLocacao        = writable("/imoveis/locacao#nt=-3&tipo_negociacao=-3&cidade=Porto%20Alegre");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/imobiliariayara/");
export const linkInstagram      = writable("https://www.instagram.com/imobiliariayara/");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("https://twitter.com/imobiliariayara");

export const linkMapa           = writable("https://goo.gl/maps/YsXwk5F4wBYyVfvx8");
export const linkWaze           = writable("https://ul.waze.com/ul?place=ChIJ4f18gd15GZURlYWPlgcSlU8&ll=-30.00739100%2C-51.18722000&navigate=yes");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=9zzPwceWa0hEu1fLOgKkUoEp0EmIVgjH&pickup=my_location&dropoff[formatted_address]=Imobili%C3%A1ria%20Yara%20-%20Avenida%20Benjamin%20Constant%20-%20S%C3%A3o%20Jo%C3%A3o%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.007391&dropoff[longitude]=-51.187220");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.0268176967197!2d-51.18940868503493!3d-30.007386336514095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951979dd817cfde1%3A0x4f951207968f8595!2sYara%20Imobili%C3%A1ria!5e0!3m2!1spt-BR!2sbr!4v1607014592752!5m2!1spt-BR!2sbr");

export const linkAPI            = writable("http://www.api.com.br");
export const linkAV             = writable("https://appimobiliariayara.com.br/yara/login");
export const linkAVConheca      = writable("https://appimobiliariayara.com.br/conheca/");

export const linkBoletoFacil    = writable("https://appimobiliariayara.com.br/yara/login?boleto-facil=1");

export const textAtendimento            = writable("De segunda à sexta, das 9h às 18h.");
export const textAtendimentoVendas      = writable("De segunda à sexta, das 9h às 19h.");
export const textEndereco               = writable("Av. Benjamin Constant, 179 <br> São João, Porto Alegre - RS <br> CEP 90550-000");
export const textCNPJ                   = writable("92642610000107");
export const textCreci                  = writable("22.142-J");